import '../../DataTable.css';
import './ColumnSizing.css';
export var tableColumnResizing = '_17437gx0-3-8-0';